import type { AbilityDef } from "../../sim";

/**
 * «Взлёт»: ↓ ↑ (вниз, затем вверх, без кнопки) — мощный прыжок вверх с огненным апперкотом: сбивает прыгнувшего
 * (против прыжков) и уводит в бой в воздухе. Без Ярости. Джон 04.11.2026, 23:00: «Можно так же придумать комбинацию
 * для (вниз-вверх)»; приём — решение консультанта.
 */
export const RISING_STRIKE: AbilityDef = {
  id: "rising-strike",
  name: "Взлёт",
  input: { gesture: ["D", "U"] },
  pose: "risingStrike",
  startup: 4,
  active: 12,
  recovery: 10,
  actions: [{ frame: 3, type: "leap", params: { up: 21, forward: 1 } }],
  hitbox: { x: 4, y: -200, w: 58, h: 170 },
  hit: { damage: 70, hitstun: 0, blockstun: 14, hitstop: 12, push: 3, height: "mid", launch: 18 },
  fx: { start: "fire/rise", hit: "finale/fire", block: "block/spark" },
  sound: { start: "whoosh", hit: "hit-heavy" },
};
